import axios from "const/axios";

export const pushApi = {
  register: ({ token, platform }) => axios.post("push-devices", { token, platform }),

  /** `authToken` is passed explicitly at sign-out, when the stored session is about to disappear. */
  unregister: ({ token, authToken }) =>
    axios.post(
      "push-devices/unregister",
      { token },
      authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
    ),
};
